<!--
{
  "type": "wysiwyg",
  "data": {
    "columns": 2,
    "title": "Slice Title",
    "content": [
      "<p>Col 1 content</p>",
      "<p>Col 2 content</p>",
    ]
  }
}
-->
<template>
  <b-container>
    <b-row v-if="title">
      <b-col><h3>{{ title }}</h3></b-col>
    </b-row>
    <b-row
      class="wysiwyg-content-region"
      :cols="getMinCols(1)"
      :cols-sm="getMinCols(1)"
      :cols-md="getMinCols(numColumns % 2 ? 3 : 2)"
      :cols-lg="getMinCols(4)"
      :cols-xl="getMinCols(4)"
    >
      <b-col
        v-for="n in numColumns"
        :key="`wysiwyg-column-${n}`"
        v-html="getColumnContent(n - 1)"
      />
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'slice-type-wysiwyg',
  props: {
    slice: {
      type: Object,
      required: false,
      default: function() {
        return {}
      }
    }
  },
  computed: {
    data() {
      return this.slice.data
    },
    numColumns() {
      return this.data.columns
    },
    title() {
      return this.data.title
    },
    content() {
      return this.data.content
    }
  },
  methods: {
    getMinCols(brk) {
      return Math.min(brk, this.numColumns)
    },
    getColumnContent(column) {
      // @todo: need to sanitize content for XSS
      return this.content[column]
    }
  }
}
</script>

<style scoped lang="scss">
  @import '~@scss/custom.scss';

  h3 {
    text-align: center;
  }

 ::v-deep .wysiwyg-content-region {

    h1,h2,h3,h4,h5 {
      color: var(--main-text-heading-color);
    }
    .lead {
      font-size: 1.45em;
    }
    a {
      color:var(--main-link-color);
      border-bottom: 2px solid;
      @include transition(border-color 0.3s);
      border-color: var(--main-border-color);
      @include hover-focus {
        text-decoration: none;
        border-color:var(--main-link-color);
      }
    }

    ul, ol {
      padding-left: 0.2em;
      margin: 0em 0em 1em 0em;
      overflow: auto;
      li {

        margin: 0.5em 0em 0.5em 1.5em;
      }
    }
    ul {
      li  {
        list-style-position: outside;
        list-style-type: disc;
      }
    }

    blockquote {
      border-left: 4px solid;
      font-style: italic;
      border-color: var(--main-border-color);
      padding-left: 2em;
      padding: 0.5em 0em 0.5em 2em;
      margin: 2em 0em;
      p {
        font-style: italic;
        font-size: 1.1em;
      }
    }

    //quill specific
    .ql-align-right {
      text-align: right;
    }
    .ql-align-center {
      text-align: center;
    }
  }
</style>
